import styled from 'styled-components';

import * as slabIconVars from './SlabIcon.styles.vars';

import { IMAGE_COMING_SOON } from '~/core/constants';
import { createVar, fallbackVar, vars } from '~/theme';

const _imgUrl = createVar('_slabIcon-imgUrl');
const _size = createVar('_slabIcon-size');

export const Container = styled.div.attrs({ 'aria-hidden': 'true' })({
  ...vars({
    [_imgUrl]: fallbackVar(slabIconVars.imgUrl, `url("${IMAGE_COMING_SOON}")`),
    [_size]: fallbackVar(slabIconVars.size, '30rem'),
  }),

  width: _size,
  height: _size,
  marginRight: '10rem',
  backgroundImage: _imgUrl,
  backgroundSize: 'cover',
});
